import { render, staticRenderFns } from "./TicketsConsole.vue?vue&type=template&id=87e583ac&scoped=true"
import script from "./TicketsConsole.vue?vue&type=script&lang=ts"
export * from "./TicketsConsole.vue?vue&type=script&lang=ts"
import style0 from "./TicketsConsole.vue?vue&type=style&index=0&id=87e583ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e583ac",
  null
  
)

export default component.exports